import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowDown } from "lucide-react";
import { SpinningLogo } from "./SpinningLogo";

export const scrollToContact = () => {
  const el = document.getElementById("contact");
  if (window.__lenis && el) {
    window.__lenis.scrollTo(el, { duration: 1.6 });
  } else if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

const LINES = ["Join a Mission-Critical", "Growth Platform."];

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const logoY = useTransform(scrollYProgress, [0, 1], [0, 120]);
  const logoOpacity = useTransform(scrollYProgress, [0, 0.85], [1, 0.15]);

  return (
    <section ref={ref} data-testid="hero-section" className="relative pt-24 sm:pt-28 pb-24 sm:pb-32 px-6">
      <div className="hero-blueprint" aria-hidden="true" />
      <div className="relative z-10 max-w-5xl mx-auto flex flex-col items-center text-center">
        <motion.div style={{ y: logoY, opacity: logoOpacity }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          >
            <SpinningLogo />
          </motion.div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-10 text-[11px] font-semibold tracking-[0.3em] uppercase text-[#4B5563]"
        >
          A Confidential Invitation to Machine Shop Owners
        </motion.p>

        <h1
          data-testid="hero-headline"
          className="font-heading mt-6 text-4xl sm:text-6xl lg:text-7xl font-black tracking-tight leading-[1.02] text-[#0B1B3D]"
        >
          {LINES.map((line, i) => (
            <span key={line} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.95, delay: 0.35 + i * 0.16, ease: [0.22, 1, 0.36, 1] }}
              >
                {i === 1 ? (
                  <>
                    Growth <span className="text-[#C5A059]">Platform.</span>
                  </>
                ) : (
                  line
                )}
              </motion.span>
            </span>
          ))}
        </h1>

        <span className="overflow-hidden block mt-7">
          <motion.p
            data-testid="hero-subheadline"
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.85, ease: [0.22, 1, 0.36, 1] }}
            className="font-serif-accent italic font-light text-base md:text-lg text-[#4B5563]"
          >
            Precision Without Compromise. Compliance Without Exception.
          </motion.p>
        </span>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.15, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12"
        >
          <button data-testid="hero-contact-cta" onClick={scrollToContact} className="dpm-btn-gold">
            Contact Us
            <ArrowDown size={15} strokeWidth={2.5} />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
